import { observer } from "mobx-react-lite"
import { Button, Group, createStyles } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { categoryNames } from "shared/lib/constants"
import { ArticleStore } from "app/store"
import { type ArticleCategory } from "shared/types/article"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  group: {
    gap: theme.spacing.lg,

    [theme.fn.smallerThan("md")]: {
      gap: theme.spacing.xs,
    },
  },

  button: {
    borderRadius: theme.radius.xl,
  },
}))

// ----------------------------------------------------------------------

export const ArticleCategoryFilter = observer(function ArticleCategoryFilter() {
  const { classes, theme } = useStyles()
  const matches = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`)

  const handleClick = ({ currentTarget }: React.MouseEvent<HTMLButtonElement>) => {
    const datasetValue = currentTarget.dataset.category as ArticleCategory

    ArticleStore.toggleCategory(datasetValue)
  }

  return (
    <Group mb="xl" className={classes.group}>
      {Object.keys(categoryNames).map((category) => (
        <Button
          data-category={category}
          key={category}
          color={ArticleStore.categories.includes(category as ArticleCategory) ? "blue" : "gray"}
          variant="light"
          size={matches ? "xs" : "sm"}
          onClick={handleClick}
          className={classes.button}
        >
          {categoryNames[category as ArticleCategory]}
        </Button>
      ))}
    </Group>
  )
})
